import React, { useState, useEffect } from 'react';
import './JoelympicsLanding.css';

const JoelympicsLanding = () => {
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  
  // Set the event date to May 3rd, 2025
  useEffect(() => {
    const eventDate = new Date('May 3, 2025 00:00:00');
    
    const timer = setInterval(() => {
      const now = new Date();
      const difference = eventDate.getTime() - now.getTime();
      
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);
      
      setCountdown({ days, hours, minutes, seconds });
    }, 1000);
    
    return () => clearInterval(timer);
  }, []);
  
  return (
    <div className="landing-page">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="logo">JOELYMPICS <span className="gold-text">2025</span></div>
        </div>
      </header>
      
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-image-container">
              {/* Replace with your actual image path */}
              <img src="/joe-olympics-logo-landscape.png" alt="Joelympics Logo" className="hero-image" />
              <div className="coming-soon-overlay">COMING SOON</div>
            </div>
            
            <h1 className="title"><span className="gold-text">JOE</span>LYMPICS</h1>
            
            <p className="subtitle">
              Celebrating the 25th Anniversary of Joe's Existence with the Greatest Sporting Event of All Time
            </p>
            
            {/* Countdown Timer */}
            <div className="countdown-container">
              <div className="countdown-item">
                <div className="countdown-value">{countdown.days}</div>
                <div className="countdown-label">DAYS</div>
              </div>
              
              <div className="countdown-item">
                <div className="countdown-value">{countdown.hours}</div>
                <div className="countdown-label">HOURS</div>
              </div>
              
              <div className="countdown-item">
                <div className="countdown-value">{countdown.minutes}</div>
                <div className="countdown-label">MINUTES</div>
              </div>
              
              <div className="countdown-item">
                <div className="countdown-value">{countdown.seconds}</div>
                <div className="countdown-label">SECONDS</div>
              </div>
            </div>
            
            {/* Save the Date Banner */}
            <div className="save-date-container">
              <div className="save-date-banner">
                <h3>SAVE THE DATE</h3>
                <p className="date">MAY 3RD, 2025</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Teaser Section */}
      <section className="teaser-section">
        <div className="container">
          <div className="teaser-grid">
            <div className="teaser-card">
              <div className="teaser-icon">🏆</div>
              <h3>EVENTS</h3>
              <p>Prepare for extraordinary challenges that will test strength, endurance, and ability to have fun!</p>
            </div>
            
            <div className="teaser-card">
              <div className="teaser-icon">🏟️</div>
              <h3>VENUE</h3>
              <p>A world-class facility (well, sort of) prepared specifically for this momentous occasion.</p>
            </div>
            
            <div className="teaser-card">
              <div className="teaser-icon">🎉</div>
              <h3>CELEBRATION</h3>
              <p>Not just competition - an epic celebration worthy of Joe's quarter-century milestone!</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Torch Section */}
      <section className="torch-section">
        <div className="container">
          <div className="torch-content">
            <div className="torch">
              <div className="torch-flame"></div>
              <div className="torch-handle"></div>
            </div>
            <h2>The Flame Will Be Lit</h2>
            <p>
              As tradition dictates, Joe himself will light the ceremonial Joelympics flame to mark the beginning of this historic event.
            </p>
          </div>
        </div>
      </section>
      
      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="olympic-rings">
            <div className="ring blue"></div>
            <div className="ring black"></div>
            <div className="ring red"></div>
            <div className="ring yellow"></div>
            <div className="ring green"></div>
          </div>
          
          <div className="footer-content">
            <p>© 2025 Joelympics. All rights reserved.</p>
            <p>This is not affiliated with any actual Olympic committee. It's just for Joe's birthday.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default JoelympicsLanding;